import { useCallback } from 'react';
import { useTheme } from '@mui/material';

import { GridContainer, GridItem } from '@formComponents';
import { normalizeIso8601Date } from '@libs/dateTime';

import {
    TimeSheetsNavigator,
    TimesheetsYearPicker
} from 'timeAndAttendance/components';
import useYearlyTimesheets, {
    SET_YEAR,
    TIMESHEET_NEXT_YEAR,
    TIMESHEET_PREV_YEAR
} from './useYearlyTimesheets';

const Filters = () => {
    const { spacing } = useTheme();
    const [{ year, isNextDisabled }, dispatch] = useYearlyTimesheets();

    const handleYearChange = useCallback(
        (value) => {
            try {
                if (value) {
                    const normalized = normalizeIso8601Date(value);
                    if (!normalized.includes('Invalid Date')) {
                        dispatch({
                            type: SET_YEAR,
                            payload: new Date(normalized).getFullYear()
                        });
                    }
                }
            } catch {}
        },
        [dispatch]
    );

    const handlePrevClick = useCallback(() => {
        dispatch({ type: TIMESHEET_PREV_YEAR });
    }, [dispatch]);

    const handleNextClick = useCallback(() => {
        dispatch({ type: TIMESHEET_NEXT_YEAR });
    }, [dispatch]);

    return (
        <GridContainer sx={{ paddingBottom: spacing(2) }}>
            <GridItem md={4}>
                <TimeSheetsNavigator
                    onPrevClick={handlePrevClick}
                    onNextClick={handleNextClick}
                    isNextDisabled={isNextDisabled}
                >
                    <TimesheetsYearPicker
                        input={{
                            value: `${year}-01-01`,
                            onChange: handleYearChange
                        }}
                    />
                </TimeSheetsNavigator>
            </GridItem>
        </GridContainer>
    );
};

export default Filters;
